<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>출항일정/예약하기</h3>
                        </div>                        
                        <div class="mt-5 py-5 border-top text-center" 
                            style="display: flex; justify-content: center;"
                        >
                            <Booking></Booking>
                        </div>                        
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>

import Booking from './components/BookingHome.vue';

export default {
    name : "booking",
    components:{
        Booking
    }
};
</script>
<style>
</style>
